import Table from "components/Table";
import WrapperDate from "./Component/WrapperDate";
import ReleaseModal from "../CreateInvestmentFund/Component/ViewFixedYearlyProfit/Component/TableViewFixedYearlyProfit/Component/ReleaseModal";
import { useEffect, useState } from "react";
import useIsMobileView from "hooks/useIsMobileView";
import FixedBox from "./Component/FixedBox";
import { Box, Grid, Typography } from "@mui/material";
import useDispatch from "hooks/useDispatch";
import { getInvestmentFixedCurrentlyList } from "store/slices/investment/investmentSlice";
import { useSelector } from "react-redux";
import Amount from "./Component/Amount";
import ProfitLost from "./Component/ProfitLost";
import Total from "./Component/Total";
import Status from "./Component/Status";
import Action from "./Component/Action";
import { INVESTMENT_ACTION } from "./constants";
import CancelFixedInvestment from "./Component/CancelFixedInvestment";
import RemainingBar from "./Component/RemainingBar";
import ConfirmCloseInvestmentFixedDetails from "./Component/ConfirmCloseInvestmentFixedDetails";
import NumberFormats from "components/NumberFormats";
import { repeat } from "utils/helpers/interval";

const headersFixed = [
  {
    key: "portfolioOwner",
    name: "Name",
    align: "center",
  },
  {
    key: "createDate",
    name: "Create Date",
    align: "left",
  },
  {
    key: "amountData",
    name: "Amount",
    align: "left",
  },
  {
    key: "profitOrLoss",
    name: "Profit/Loss",
    align: "center",
  },
  {
    key: "profitOrLossTrader",
    name: "SanaCash Profit",
    align: "center",
  },
  {
    key: "totalData",
    name: "Total",
    align: "center",
  },
  {
    key: "stateFirst",
    name: "Status",
    align: "center",
  },
  // {
  //   key: "remainingBar",
  //   name: "Remaining Days",
  //   align: "center",
  // },
  {
    key: "stateSecond",
    name: "Action",
    align: "center",
  },
];

let getInvestmentFixedCurrentlyListInterval = null

function TableFixed({ setCreateInvestmentKey }) {
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView();

  const investmentFixedList = useSelector((state) => state.investment?.investmentFixedList?.data)

  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const [dataRelease, setDataRelease] = useState("");
  const [openAction, setOpenAction] = useState(null)
  const [actionData, setActionData] = useState(null)

  const handleShowDetails = (data) => {
    setOpenReleaseModal(true);
    setDataRelease(data);
  };

  const handleOpenAction = async (data) => {
    setActionData(data)

    const action = data.stateSecondId

    setOpenAction(action)
  };

  const handleCloseAction = () => {
    setCreateInvestmentKey((v) => v + 1)

    setActionData(null)

    setOpenAction(null)
  }

  const formattedItemsFixed = investmentFixedList?.map((item) => ({
    ...item,
    portfolioOwner: <>
      <Typography textAlign={"center"}>
        {item?.portfolioOwner}
      </Typography>
      <Typography variant="subtitle1" textAlign={"center"}>
        {item?.portfolioFixedInvestment}
      </Typography>
    </>,
    amountData: <Amount data={item} />,
    profitOrLoss: <ProfitLost data={item} isPercent={false} />,
    createDate: (<Box>
      <WrapperDate date={item?.date} time={item?.time} />
      <RemainingBar data={item} />
    </Box>),
    totalData:
      <>
        <Total data={item} />
        <Typography pl={1} variant="subtitle1" >
          {item?.totalPercent}%
        </Typography>
      </>
    ,
    profitOrLossTrader:
       <Typography variant="h6" color="text.main">
        <NumberFormats value={item?.profitOrLossTrader} /> {" "}
        <Typography
          component="span"
          variant="subtitle1"
          color="text.secondary"
        >
          {item?.coinName}
        </Typography>
      </Typography>
    ,
    stateFirst: <Status data={item} />,
    // remainingBar: <RemainingBar data={item} />,
    stateSecond: (
      <Action
        data={item}
        handleShowDetails={handleShowDetails}
        handleShowAction={handleOpenAction}
      />
    ),
  }));


  useEffect(() => {
    dispatch(getInvestmentFixedCurrentlyList())

    clearInterval(getInvestmentFixedCurrentlyListInterval);

    getInvestmentFixedCurrentlyListInterval = repeat({
      action: () => dispatch(getInvestmentFixedCurrentlyList({ coinDestinationId: -1 })),
    });

    return () => {
      clearInterval(getInvestmentFixedCurrentlyListInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isMobileView ? (
        <Grid container spacing={2}>
          {investmentFixedList?.map((fixedFundItem) => (
            <Grid item xs={12}>
              <FixedBox
                fixedFundItem={fixedFundItem}
                handleShowDetails={handleShowDetails}
                handleShowAction={handleOpenAction}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Table headers={headersFixed} items={formattedItemsFixed} />
      )}


      {
        openAction === INVESTMENT_ACTION.close.id &&
        <ConfirmCloseInvestmentFixedDetails
          open={openAction === INVESTMENT_ACTION.close.id}
          data={actionData}
          onClose={handleCloseAction}
        />
      }

      {
        openAction === INVESTMENT_ACTION.cancel.id &&
        <CancelFixedInvestment
          open={openAction === INVESTMENT_ACTION.cancel.id}
          data={actionData}
          onClose={handleCloseAction}
        />
      }

      {openReleaseModal && (
        <ReleaseModal
          dataRelease={dataRelease}
          open={openReleaseModal}
          onClose={() => setOpenReleaseModal(false)}
        />
      )}
    </>
  );
}
export default TableFixed;
